module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "topBox",
    style: ('margin-top:' + (_vm.playHeight + _vm.pieceHeight) + 'px')
  }, [_c('div', {
    staticClass: "scroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollList"
  }, [(_vm.news.length) ? _c('ul', {
    style: ({
      top: _vm.top
    })
  }, _vm._l((_vm.news), function(item) {
    return _c('li', [_vm._v(_vm._s(item.nick) + " 获得了 "), _c('span', [_vm._v(_vm._s(item.money / 100))]), _vm._v(" 元分享收益")])
  }), 0) : _c('ul', {
    style: ({
      top: _vm.top
    })
  }, [_c('li', [_vm._v("暂无数据")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news"
  }, [_c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/toupiao/horn.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("分销动态：")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36cad140"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/Top.vue
// module id = 285
// module chunks = 0